import { render, staticRenderFns } from "./UsrArtList.vue?vue&type=template&id=0b039abd&scoped=true&"
import script from "./UsrArtList.vue?vue&type=script&lang=js&"
export * from "./UsrArtList.vue?vue&type=script&lang=js&"
import style0 from "./UsrArtList.vue?vue&type=style&index=0&id=0b039abd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b039abd",
  null
  
)

export default component.exports